import { Formik } from 'formik';
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { useQueryClient } from 'react-query';

import { autocompleteEntities } from '../../../../utils/backend-api/entities';
import { createEntityJoin } from '../../../../utils/backend-api/entity_joins';
import { IDENTITIES_KEY } from '../../../../utils/backend-api/identities';
import { AutoSave } from '../../../BaseUI';
import { AutocompleteField } from '../../../FormFields';

const INITIAL_FORM_STATE = {};

const AddTopicForm = ({ identityId }) => {
  const queryClient = useQueryClient();

  const handleSubmit = async (values, { setFieldValue }) => {
    if (!values.entity?.value) return;
    const sanitizedParams = {
      entity_id: values.entity?.value,
      entity_source: 'topic',
      parent_type: 'Identity',
      parent_id: identityId,
    };
    try {
      const result = await createEntityJoin(sanitizedParams);
      if (result) {
        queryClient.invalidateQueries([IDENTITIES_KEY, identityId]);
        setFieldValue('entity', '');
      } else {
        // Let catch handle response to user
        throw 'createEntityJoin result unsuccessful';
      }
    } catch (e) {
      console.error('Failed to createEntityJoin: ', e, sanitizedParams);
      toast.error('Sorry, something went wrong adding that topic. Please try again');
    }
  };
  return (
    <Formik onSubmit={handleSubmit} initialValues={INITIAL_FORM_STATE}>
      {(formik) => (
        <Form noValidate onSubmit={formik.handleSubmit}>
          <AutoSave debounceMs={500} />
          <div className="flexbox">
            <Col className="select-form-container">
              <AutocompleteField
                name="entity"
                className="mt0"
                isCreatable={false}
                fetchMethod={(value) =>
                  autocompleteEntities({
                    fragment: value,
                  })
                }
              />
            </Col>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AddTopicForm;
